import Simplemodal from '../../plugins/simplemodal.js';

const simplemodal = new Simplemodal();